import '.ag{flex-shrink:0;}.ssr-plugin'
import '.aa{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.ay{height:100%;}.ssr-plugin'
import '.be{border:none;}.ssr-plugin'
import '.cj{background-color:transparent;}.ssr-plugin'
import '.ck{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.br{position:sticky;}.ssr-plugin'
import '.cl{top:4rem;}.ssr-plugin'
import '.cm{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.cn{padding-bottom:1rem;}.ssr-plugin'
import '.co{margin-bottom:1rem;}.ssr-plugin'
import '.cp{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bs{top:0px;}.ssr-plugin'
import '.bz{left:0px;}.ssr-plugin'
import '.c0{right:0px;}.ssr-plugin'
import '.c1{bottom:0px;}.ssr-plugin'
import '.cq{z-index:9999;}.ssr-plugin'
import '.cr{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cc{justify-content:flex-end;}.ssr-plugin'
import '.az{flex:1;}.ssr-plugin'
import '.ca{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ag aa l ay be cj ck"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a2"
    >
      <div className="br cl cm t cn co cp d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bs bz c0 c1 cq t cr d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aa d cc cp"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="az ca">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
